import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import {ElementMouseEvent} from 'util/Types';

const styles = StyleSheet.create({
  dragHandle: {
    cursor: 'grab',
  },
});

export const DRAG_HANDLE_CLASS = css(styles.dragHandle);

export interface DnDDragHandleProps {
  // className is only used to change the cursor to a "grab" cursor
  className: string;
  onMouseDown: (e: ElementMouseEvent) => void;
}

export function DnDDragHandleIcon(props: DnDDragHandleProps): JSX.Element {
  return <BenchlingIcon icon="drag-handle" {...props} />;
}

export function DnDDragHandleArea(props: DnDDragHandleProps): JSX.Element {
  const modifiedProps = {
    ...props,
    className: classNames(props.className, 'u-height-full', 'u-flex-grow'),
  };

  return <div {...modifiedProps} />;
}
